import { faInfo, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import UpdatingPopover from "../../../core/UpdatingPopover";
import { labels } from "../../../../localization/labels";
import Pdf from "../../../../assets/KM_user_manual.pdf";

const Help = props => {
  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      opacity="1"
      rootClose
      overlay={
        <UpdatingPopover>
          <Popover.Content className="popoverInfo">
            <div>
              <Button variant="link" text="Info" onClick={props.handleHelpShow}>
                <FontAwesomeIcon icon={faInfo} /> {labels.information}
              </Button>
            </div>
            <div>
              <Button
                variant="link"
                onClick={() => {
                  window.open(Pdf);
                }}
              >
                <FontAwesomeIcon icon={faQuestion} /> {labels.help}
              </Button>
            </div>
          </Popover.Content>
        </UpdatingPopover>
      }
    >
      <Button className="btnInfo">
        <FontAwesomeIcon
          className="btnInfoHover"
          icon={faInfo}
        ></FontAwesomeIcon>
      </Button>
    </OverlayTrigger>
  );
};

export default Help;
